export default __webpack_public_path__ + "locales/zh-CN/EmbeddingPanel.json?hash=27585180f63b47e4a13986c67c7e0fa7";